module.exports = "/images/piscina.svg?736cf1853b828aa8f167ae3c659fa51f";